import {SpriteImage} from "@COMPONENTS/style/detailpackage/couponselect";
import {FlexProps} from "@FRAMEWORK/ui/types/d";
import styled from "styled-components";

const Container = styled.div`
	width: 1200px;
	margin: 0 auto;
	padding-bottom: 100px;
`;

const Flex = styled.div<FlexProps>`
	display: flex;
	align-items: ${props => props.align};
	flex-direction: ${props => (props.direction ? "column" : "row")};
	justify-content: ${props => props.justify};
	gap: ${props => (props.gap ? props.gap : "0")}px;
	line-height: ${props => props.lineHeight};
	flex-wrap: ${props => props.wrap};
	flex-grow: ${props => props.grow};
`;

const LineHeader = styled.div`
	display: flex;
	width: 100%;
	padding: 15px 0;
	border-bottom: 2px solid var(--emp-color);
	line-height: 1.25;
	align-items: baseline;
`;

const ProdutList = styled.ul`
	padding: 30px 0;
	border-top: 1px solid var(--line-color);
`;

const Stack = styled.div`
	display: flex;
	line-height: 1;
	flex-direction: row;
	align-items: baseline;
`;

const SubTitleWrap = styled.div`
	margin: 60px 0 20px;
`;

const DescriptionWrap = styled.div`
	position: relative;
`;

const DescriptionContent = styled.div`
	width: 910px;
`;

const LineBox = styled.div<{elementHeight?: string}>`
	line-height: 1.6;
	margin-top: 20px;
	max-height: ${props => props.elementHeight};
	overflow: hidden;

	> div {
		${props =>
			props.elementHeight && props.elementHeight !== "auto"
				? `
					max-height: 245px;
				`
				: ``}
	}

	/* pc */
	@media (min-width: 736px) {
		border: 1px solid var(--line-color);
		padding: 35px 40px 40px;
		box-sizing: border-box;
	}
`;

const NoteBox = styled.div<{icon?: string}>`
	line-height: 1.6;
	padding: 38px 40px 36px;
	background-color: #f3f3f3;
	font-size: var(--default-size);

	h4,
	p {
		padding-left: 28px;
		color: var(--emp-color);
	}

	h4 {
		position: relative;
		margin-bottom: 5px;

		&:before {
			position: absolute;
			left: 0;
			top: 50%;
			display: block;
			width: 18px;
			height: 18px;
			transform: translateY(-50%);
			content: "";
		}
	}

	p {
		line-height: 1.6;
	}

	${props =>
		props.icon === "point" &&
		`
		h4 {
			&:before {
				background: url(${SpriteImage}) no-repeat 0px -328px;
			}
		}
	`}

	${props =>
		props.icon === "question" &&
		`
		h4 {
			&:before {
				height: 19px;
				background: url(${SpriteImage}) no-repeat 0 -266px;
			}
		}
	`}
`;

export {
	Container,
	Flex,
	LineHeader,
	ProdutList,
	Stack,
	SubTitleWrap,
	DescriptionWrap,
	DescriptionContent,
	LineBox,
	NoteBox,
};
export {CompareTextBox, CompareButtonBox} from "./CompareBox";
export {default as WarningBox} from "./WarningBox";
